
import { Link } from 'react-router-dom';
import { SheetClose } from "@/components/ui/sheet";

interface MobileNavLinkProps {
  to: string;
  children: React.ReactNode;
}

const MobileNavLink = ({ to, children }: MobileNavLinkProps) => (
  <SheetClose asChild>
    <Link
      to={to}
      className="px-4 py-2 text-redflags-gray hover:text-redflags-dark rounded-md text-base"
    >
      {children}
    </Link>
  </SheetClose>
);

export default MobileNavLink;
